import React, { useEffect, useState } from 'react';
import ModalFormVehicleClasses from '../../components/forms/catalog/modal.form.vehicleClasses';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListVehicleClasses() {
  const [msgGet ,setMsgGet] = useState('');
  const [VehicleClasses,setVehicleClasses] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });
  useEffect(() => {
    getClasses()
  }, []);

  const createVehicleClasse = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getClasses();
  };


  const editButton = (row) => {
    return (
      <ModalFormVehicleClasses
        title="Modificar Clase"
        button_text="Editar"
        button_variant="outline-primary"
        vehiClassSelect={row.id}
        callback={createVehicleClasse}
      ></ModalFormVehicleClasses>
    );
  };

  const getClasses = async()=>{
    const responsevehicleClasses = await get('/catalog/vehicleclass/',{})
    if(responsevehicleClasses.success){
      setVehicleClasses(responsevehicleClasses.data);
    }else{
      setMsgGet(responsevehicleClasses.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormVehicleClasses
        title="Crear Clase"
        button_text="Crear Clase"
        button_variant="primary"
        callback={createVehicleClasse}
      ></ModalFormVehicleClasses>
      <ListTables
        data={VehicleClasses}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListVehicleClasses;
